import { isMobileDevice } from "@/plugins/MobileDetection";

const openUrlInNewTab = function (params) {
  const _openUrl = function (params) {
    this.$router.push(params).catch(() => {});
  };

  const _openUrlInNewTab = function (params) {
    if (isMobileDevice()) {
      _openUrl.call(this, params);
    } else {
      window.open(this.$router.resolve(params).href, '_blank');
    }
  };

  return _openUrlInNewTab.call(this, params);
};

export default {
  install(Vue) {
    Vue.prototype.$openUrlInNewTab = function (params) {
      return openUrlInNewTab.call(this, params);
    };
  }
};
